import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Custom toast configuration with #49ba09 theme
const toastConfig = {
    position: "top-right",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    style: {
        background: '#49ba09',
        color: '#ffffff',
    },
    progressStyle: {
        background: '#ffffff',
    }
};

// Success toast with green background
export const showSuccess = (message) => {
    toast.success(message, {
        ...toastConfig,
        style: {
            background: '#49ba09',
            color: '#ffffff',
        }
    });
};

// Error toast with red background
export const showError = (message) => {
    toast.error(message, {
        ...toastConfig,
        style: {
            background: '#dc3545',
            color: '#ffffff',
        }
    });
};

// Info toast with blue background
export const showInfo = (message) => {
    toast.info(message, {
        ...toastConfig,
        style: {
            background: '#17a2b8',
            color: '#ffffff',
        }
    });
};

// Warning toast with orange background
export const showWarning = (message) => {
    toast.warning(message, {
        ...toastConfig,
        style: {
            background: '#ffc107',
            color: '#000000',
        }
    });
};

// Default toast with green background
export const showToast = (message) => {
    toast(message, toastConfig);
};
